// Frittstående chat-panel (poppet ut til egen skjerm — TOC-arbeidsplass). Egen
// WS-feed (cookie-auth); sender/mottar via hubbens collab-kanal.
import { parseChatEvent } from '@skade/contracts';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import type { User } from '@skade/rbac';
import { ChatPanel } from '../ui/chat.js';

export function mountChatPanel(root: HTMLElement, feed: Feed, _sync: SyncBus, user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const wrap = document.createElement('div');
  wrap.className = 'standalone-panel';
  const head = document.createElement('div');
  head.className = 'standalone-head';
  head.append(span('brand', 'SKADE'), span('standalone-title', 'Chat / TOC'));
  wrap.append(head);

  const chat = new ChatPanel({
    selfId: user.id,
    embedded: true,
    onEvent: (e) => feed.send?.({ type: 'chat', chat: e }),
  });
  wrap.append(chat.el);
  root.append(wrap);

  feed.onCollab?.((m) => { if (m.kind === 'chat' && m.chat) { const e = parseChatEvent(m.chat); if (e) chat.ingestEvent(e); } });
  feed.start();
}

function span(cls: string, text: string): HTMLElement { const e = document.createElement('span'); e.className = cls; e.textContent = text; return e; }
